import ajax from '@/lib/ajax';
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { AppModule } from '@/store/modules/app';
import FilterJobScheduleRequest from '@/models/Jobs/FilterJobScheduleRequest';
import FilterJobScheduleViewModel from '@/models/Jobs/FilterJobScheduleViewModel';
import BranchDto from '@/models/Branches/BranchDto';
import DeskDto from '@/models/Desks/DeskDto';
import UserProfileDto from '@/models/Users/UserProfileDto';
import CompanyProfileSearchRequest from '@/models/Companies/CompanyProfileSearchRequest';
import LocationProfileSearchRequest from '@/models/Locations/LocationProfileSearchRequest';
import CompanyProfileDto from '@/models/Companies/CompanyProfileDto';
import LocationProfileDto from '@/models/Locations/LocationProfileDto';
import { AgencySettingsModule } from './agencySettings';
import JobWorkerInterviewDto from '@/models/JobWorkerInterviews/JobWorkerInterviewDto';
import CurrentJobScheduleSearchCriteria from '@/models/Jobs/CurrentJobScheduleSearchCriteria';
import JobScheduleEventViewModel from '@/models/Jobs/JobScheduleEventViewModel';
import JobWorkerInterviewType from '@/models/JobWorkerInterviews/JobWorkerInterviewType';
import DateTimeUtils from '@/lib/dateTimeUtils';
import CalendarType from '@/models/Shared/CalendarType';
import JobScheduleResponse from '@/models/Jobs/JobScheduleResponse';
import JobScheduleEventType from '@/models/Jobs/JobScheduleEventType';
import JobWorkerOfferDto from '@/models/JobWorkerOffers/JobWorkerOfferDto';

export interface IAgencyScheduleState {
  loading: boolean;
  jobEvents: JobScheduleEventViewModel[];
  filterJobScheduleViewModel: FilterJobScheduleViewModel;
  currentJobScheduleSearchCriteria: CurrentJobScheduleSearchCriteria;
  loadingDialog: boolean;
  
}

@Module({ dynamic: true, store, name: 'AgencySchedule', namespaced: true})
class AgencySchedule extends VuexModule implements IAgencyScheduleState {
  
  public loading = true;
  public jobEvents: JobScheduleEventViewModel[] = [];
  public filterJobScheduleViewModel: FilterJobScheduleViewModel = new FilterJobScheduleViewModel();
  public currentJobScheduleSearchCriteria: CurrentJobScheduleSearchCriteria = new CurrentJobScheduleSearchCriteria();
  public loadingDialog = false;

  @Action 
  async mapUserDefaults() {
    const userProfile = AppModule.userProfile;
    this.context.commit("setUserDefaults", userProfile);
  }

  @Action
  async getJobSchedule() {
    const request = new FilterJobScheduleRequest();

    if (this.filterJobScheduleViewModel.selectedBranch != null) {
      request.branchId = this.filterJobScheduleViewModel.selectedBranch.id;
    }

    if (this.filterJobScheduleViewModel.selectedDesk != null) {
      request.deskId = this.filterJobScheduleViewModel.selectedDesk.id;
    }
    
    request.from = this.filterJobScheduleViewModel.from;
    //const fromAsDate = new Date(this.filterJobScheduleViewModel.from + "T00:00:00Z");
    //const toAsDate = new Date(this.filterJobScheduleViewModel.from + "T00:00:00Z");
    //subtract one day to catch the overlaps
    //fromAsDate.setDate(fromAsDate.getDate() -1);
    //request.from = fromAsDate.toISOString().substring(0,10);

    // if (this.filterJobScheduleViewModel.calendarType === CalendarType.Day) {
    //   //Single day - just add one for overlap
    //   toAsDate.setDate(toAsDate.getDate() + 1);
    //   request.to = toAsDate.toISOString().substring(0,10);
    //   this.filterJobScheduleViewModel.to = request.to;
    // } else if (this.filterJobScheduleViewModel.calendarType === CalendarType.FourDay) {
    //   //Add four days plus one for overlap
    //   toAsDate.setDate(toAsDate.getDate() + 5);
    //   request.to = toAsDate.toISOString().substring(0,10);
    //   this.filterJobScheduleViewModel.to = request.to;
    // } else if (this.filterJobScheduleViewModel.calendarType === CalendarType.Week) {
    //   //Add seven days plus one for overlap
    //   toAsDate.setDate(toAsDate.getDate() + 8);
    //   request.to = toAsDate.toISOString().substring(0,10);
    //   this.filterJobScheduleViewModel.to = request.to;
    // }

    if (this.filterJobScheduleViewModel.selectedCompany != null) {
      request.companyId = this.filterJobScheduleViewModel.selectedCompany.id;
    }

    if (this.filterJobScheduleViewModel.selectedLocation != null) {
      request.locationId = this.filterJobScheduleViewModel.selectedLocation.id;
    }


    this.setLoading(true);
    await ajax.post(`/api/v1/agency/jobs/search-schedule/week`, request)
    .then(response => {
      if (response.data === null) {
          response.data = [];
      }
      this.context.commit("setJobSchedule", response.data);
      this.setLoading(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      this.setLoading(false);
    });
  }

  @Action
  async getCompaniesForSearchOptions() {
    const request = new CompanyProfileSearchRequest();
    //this.setLoading(true);
    await ajax.post(`/api/v1/agency/companies/search`, request)
    .then(response => {
      if (response.data === null) {
        response.data = [];
      }
      this.context.commit("setCompanies", response.data);
      //this.setLoading(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      //this.setLoading(false);
    });
  }

  @Action
  async getLocationsForSearchOptions() {
    const request = new LocationProfileSearchRequest();
    //this.setLoading(true);
    await ajax.post(`/api/v1/agency/locations/search`, request)
    .then(response => {
      if (response.data === null) {
        response.data = [];
      }
      this.context.commit("setLocations", response.data);
      //this.setLoading(false);
    })
    .catch(error => {
      AppModule.handleApiError(error);
      //this.setLoading(false);
    });
  }

  @Action
  cleanState() {
    this.context.commit("resetState");
  }

  @Mutation
  resetState() {
    this.loading = true;
    this.loadingDialog = false;
    this.filterJobScheduleViewModel = new FilterJobScheduleViewModel();
  }

  @Mutation 
  private async setUserDefaults(userProfile: UserProfileDto) {
    let branch: BranchDto = null;
    if (userProfile.defaultBranchId !== null) {
      //Loop through each branch until we find the correct one
      branch = AgencySettingsModule.branches.find((findBranch: BranchDto) => findBranch.id === userProfile.defaultBranchId);
      if (branch != undefined) {
        this.filterJobScheduleViewModel.selectedBranch = branch;
      }
    }
    if (userProfile.defaultDeskId !== null) {
      //Loop through each desk until we find the correct one
      if (branch !== undefined)
      var desk = branch.desks.find((findDesk: DeskDto) => findDesk.id === userProfile.defaultDeskId);
      if (desk !== undefined) {
        this.filterJobScheduleViewModel.selectedDesk = desk
      }
    }
  }

  @Mutation
  private async setLoading(isLoading: boolean) {
      this.loading = isLoading;
  }

  @Mutation
  private async setLoadingDialog(isLoadingDialog: boolean) {
      this.loadingDialog = isLoadingDialog;
  }

  @Mutation
  private async setCompanies(companies: CompanyProfileDto[]) {
      this.filterJobScheduleViewModel.companies = companies;
  }

  @Mutation
  private async setLocations(locations: LocationProfileDto[]) {
      this.filterJobScheduleViewModel.locations = locations;
  }

  @Mutation
  private async setJobSchedule(jobSchedule: JobScheduleResponse) {
    // Update the latest search criteria 
    this.currentJobScheduleSearchCriteria = new CurrentJobScheduleSearchCriteria();
    this.currentJobScheduleSearchCriteria.from = this.filterJobScheduleViewModel.from;//DateTimeUtils.toDDMMYY(new Date(this.filterJobScheduleViewModel.from + "T00:00:00Z"));
    //this.currentJobScheduleSearchCriteria.to = DateTimeUtils.toDDMMYY(new Date(this.filterJobScheduleViewModel.to + "T00:00:00Z"));
    this.currentJobScheduleSearchCriteria.selectedCompany = this.filterJobScheduleViewModel.selectedCompany;
    this.currentJobScheduleSearchCriteria.selectedLocation = this.filterJobScheduleViewModel.selectedLocation;
    this.currentJobScheduleSearchCriteria.selectedBranch = this.filterJobScheduleViewModel.selectedBranch;
    this.currentJobScheduleSearchCriteria.selectedDesk = this.filterJobScheduleViewModel.selectedDesk;

    const interviewEvents = jobSchedule.jobWorkerInterviews.map(function(jobWorkerInterview: JobWorkerInterviewDto) {
      const jobScheduleEventVM = new JobScheduleEventViewModel()
      jobScheduleEventVM.interviewStatus = jobWorkerInterview.status;
      jobScheduleEventVM.jobTitle = jobWorkerInterview.job.title;
      jobScheduleEventVM.jobId = jobWorkerInterview.jobId;
      jobScheduleEventVM.jobWorkerId = jobWorkerInterview.jobWorkerId;
      jobScheduleEventVM.workerName = jobWorkerInterview.jobWorker.worker.person.firstName + " " + jobWorkerInterview.jobWorker.worker.person.lastName;
      jobScheduleEventVM.companyName = jobWorkerInterview.job.company.brandName;
      jobScheduleEventVM.locationName = jobWorkerInterview.job.location.brandName;
      jobScheduleEventVM.startAt = new Date(jobWorkerInterview.startAt).toISOString().substring(0,10) + " " + new Date(jobWorkerInterview.startAt).toISOString().substring(11,16)
      jobScheduleEventVM.endAt = new Date(jobWorkerInterview.endAt).toISOString().substring(0,10) + " " + new Date(jobWorkerInterview.endAt).toISOString().substring(11,16)
      jobScheduleEventVM.interviewType = jobWorkerInterview.type;
      jobScheduleEventVM.type = JobScheduleEventType.Interview;

      if (jobWorkerInterview.type === JobWorkerInterviewType.InPerson) {
        //TODO
      }
      return jobScheduleEventVM;
    });

    const placementEvents = jobSchedule.jobWorkerOffers.map(function(jobWorkerOffer: JobWorkerOfferDto) {
      const jobScheduleEventVM = new JobScheduleEventViewModel()
      jobScheduleEventVM.jobTitle = jobWorkerOffer.job.title;
      jobScheduleEventVM.jobId = jobWorkerOffer.jobId;
      jobScheduleEventVM.jobWorkerId = jobWorkerOffer.jobWorkerId;
      jobScheduleEventVM.workerName = jobWorkerOffer.jobWorker.worker.person.firstName + " " + jobWorkerOffer.jobWorker.worker.person.lastName;
      jobScheduleEventVM.companyName = jobWorkerOffer.job.company.brandName;
      jobScheduleEventVM.locationName = jobWorkerOffer.job.location.brandName;
      jobScheduleEventVM.startAt = new Date(jobWorkerOffer.startDate).toISOString().substring(0,10)
      jobScheduleEventVM.type = JobScheduleEventType.Placement;
      return jobScheduleEventVM;
    });
    //This wasn't needed but leaving it for a while incase we get a similar problem.
    // //Split any events that span over midnight
    // const extraEvents = [];
    // for (let index = 0; index < this.jobWorkerInterviews.length; index++) {
    //   const event = this.jobWorkerInterviews[index];
    //   //HACK: This is a mess but currently only happens here...
    //   //Check if the event spans multiple days
    //   const startAtAsDate = new Date(event.startAt.substring(0,10) + "T" + event.startAt.substring(11,16) + ":00Z")
    //   const endAtAtAsDate = new Date(event.endAt.substring(0,10) + "T" + event.endAt.substring(11,16) + ":00Z")
    //   console.log("start:" + startAtAsDate + " end: " + endAtAtAsDate);
    //   if (!DateTimeUtils.datesAreOnSameDay(startAtAsDate, endAtAtAsDate)) {
    //     //We need to duplicate this event
    //     console.log("duplicate" + event.workerName);
    //     const duplicateEventVM = JSON.parse(JSON.stringify(event));
    //     //But change the start date to 00:00 on the endAt day (only works for events spanning one midnight)
    //     duplicateEventVM.startAt = event.endAt.substring(0,10) + "T00:00:00Z";
    //     extraEvents.push(duplicateEventVM);
    //   }
    // }
    // this.jobWorkerInterviews.concat(extraEvents);
    this.jobEvents = [];
    this.jobEvents.push(...interviewEvents);
    this.jobEvents.push(...placementEvents);
  }
}

export const AgencyScheduleModule = getModule(AgencySchedule)
